const SDK_VERSION = '7.99.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
